/**
 * This uses module.exports instead of the ES6 convention since
 * these are used by both the CLI and the blobz comoponent.
 *
 * See `/tools` for the usage.
 */

// WARNING! Objects are pass by reference and the values are mutable!
export const setObjectValue = (obj, key, value, opts = {}) => {
  const path = key.split('.');
  const lastPath = path.pop();

  let ptr = obj;
  for (let d = 0, dd = path.length; d < dd; d++) {
    const p = path[d];
    if (!ptr[p]) {
      ptr[p] =
        opts.asSchema === true && p !== 'properties'
          ? {
              type: 'object',
              additionalProperties: false,
            }
          : {};
    }
    ptr = ptr[p];
  }
  ptr[lastPath] = value;
};
